export enum Status {
  /** Part of the current split. */
  ACTIVE = 'ACTIVE',
  /** Replaced by a newer split; kept as history. */
  SUPERSEDED = 'SUPERSEDED',
  /** Its authorization was reversed. */
  REVERSED = 'REVERSED',
}
